export const calculateCardBurden = (financialBurden, bank, isConsumerCredit) => {
    const limit = financialBurden?.limitOfActiveCreditCards || 0;
    if (isConsumerCredit) {
        return (limit * bank.paramValues[1364]) / 100;
    }
    const threshold = bank.paramValues[372];
    const percent = bank.paramValues[74];
    return limit > threshold ? (limit * percent) / 100 : 0;
};
